import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefreshSquareLeftLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Refresh Square left",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2178 3H7.78313C4.83503 3 3 5.08119 3 8.02638V15.9736C3 18.9188 4.83503 21 7.78411 21H16.2178C19.1659 21 21 18.9188 21 15.9736V8.02638C21 5.08119 19.1572 3 16.2178 3Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.05859 9.66406L8.02184 11.9428L10.2879 10.9844",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.15625 11.8852C8.21463 9.59673 10.0915 7.75781 12.3994 7.75781C14.7413 7.75781 16.6425 9.659 16.6425 12.0009C16.6425 14.3478 14.7413 16.2441 12.3994 16.2441C11.1579 16.2441 10.0438 15.7138 9.26641 14.8664",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRefreshSquareLeftLine;
